import { useDispatch } from 'react-redux'
import endpointMapper from '../_endpoints'
import { usePost } from '../_hooks/usePost'

export const useReviewService = () => {
  const [, postAddReview] = usePost()
  const dispatch = useDispatch()
  const { displayName: name } = JSON.parse(localStorage.getItem('userInfoData'))

  const addReviewOnApplication = async (review) => {
    const { appReview, rating, applicationId, userSid } = review

    try {
      const response = await postAddReview({
        url: endpointMapper.reviews.addReview,
        data: {
          appReview,
          rating,
          applicationId,
          userSid
        }
      })

      if (!response) {
        console.error(
          `An unexpected error occured while posting your review. Please try again later.`
        )
      }

      response.userName = name
      dispatch({ type: 'ADD_REVIEW', payload: response })
      return response
    } catch (error) {
      console.error(`An unexpected error occured ${error}.`)
    }
  }

  return { addReviewOnApplication }
}
